export const ALL_STRING_CHARACTERS = /\D/g;
export const EMAIL_REGEX = /^\b[\w.-]+@[\w.-]+\.\w{2,4}\b$/;
export const PHONE_NUMBER_REGEX = /^[0-9 +]+$/;

export const THIRTY_NUMBERS_REGEX = /^\d{30}$/;
export const ELEVEN_NUMBERS_REGEX = /^\d{11}$/;
export const MAX_SEVEN_NUMBERS_REGEX = /^[\d#]{1,7}$/;
export const IP_REGEX = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
export const ONLY_NUMBERS_REGEX = /^[0-9]*$/;
export const NEW_LINE_REGEX = /\n|\r/g;
export const ISO_DATE_REGEX = /-/g;
export const CONTACT_NAME_REGEX = /^(.+?)\s?\(\d+\)/;
